import React from "react";
import SectionWithImg from "../../components/Sections/SectionWithImg";
import { Box } from "@mui/material";

export default function PhilosophySection({ id }) {
  return (
    <SectionWithImg
      id={id}
      title="Our Philosophy"
      img="ring_craft2.jpeg"
      colored
    >
      <Box
        sx={{
          textAlign: { xs: "center", md: "left" },
          // textAlign: { xs: "justify", md: "left" },
          paddingRight: { xs: "", lg: "5rem" },
          fontSize: { xs: "1rem", lg: "1rem" },
          lineHeight: "1.7rem",
          fontWeight: { xs: 400, md: 500 },
        }}
      >
        <p
          style={{
            marginTop: "3rem",
          }}
        >
          At rubicon®
          {/* <span
            style={{
              fontSize: "1.5rem",
              fontWeight: 700,
            }}
          >
            &#174;
          </span> */}
          , we see business projects the way a master artisan sees their craft:
          with purpose, precision and pride in the details. Just as a skilled
          craftsman shapes raw materials with technique and skill into something
          enduring, we shape businesses with the same dedication, blending
          time-honored principles such as discipline, integrity, and
          perseverance with forward-thinking strategies, agile structures, and
          innovative tools.
        </p>
        <p>
          Our Business Craftsmanship unlocks enduring growth. As the trusted
          catalyst for change, we empower SMEs and Family Businesses to achieve
          not only timely transformation, but autonomous evolution.
        </p>
        <p
          style={{
            marginTop: "3rem",
          }}
        >
          We envision a future where every enterprise thrives by integrating
          tradition with innovation, fostering sustainable growth, agile value,
          and resilience in a dynamic economy, equipped with the clarity,
          confidence, and strategic tools needed to independently sustain and
          advance their progress.
        </p>
      </Box>
    </SectionWithImg>
  );
}
